import { c as _c } from "react/compiler-runtime";
import { Button } from '@xefi/x-react/button';
import { useTranslation } from 'react-i18next';
type ErrorDisplayProps = {
  error: Error | null;
  retry?: () => void;
};
export const ErrorDisplay = t0 => {
  const $ = _c(13);
  const {
    error,
    retry
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("error.general", {
      ns: "common"
    });
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="mb-4 text-lg font-medium text-gray-600">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== error) {
    t3 = error?.message && <div className="mb-4 text-sm text-gray-500">{error.message}</div>;
    $[4] = error;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== retry || $[7] !== t) {
    t4 = retry && <Button onClick={retry}>{t("retry", {
        ns: "common"
      })}</Button>;
    $[6] = retry;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <div className="flex h-64 flex-col items-center justify-center text-center">{t2}{t3}{t4}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};